module.exports = __webpack_public_path__ + "80c6f8ab84839cdf4618414c522e3ce9.svg";